import axios from 'axios';
import { ADMIN_TOKEN } from '../utils';
import { isNetworkOrServerError } from '../utils/networkErrorUtils';

/**
 * Memanggil refresh token untuk validasi session.
 * Digunakan oleh ProtectedRoute saat mount.
 * @returns {Promise<string>} accessToken baru
 * @throws Error jika gagal (network/auth)
 */
export async function refreshTokenForValidation() {
  const res = await axios.get(ADMIN_TOKEN, { withCredentials: true });
  const token = res?.data?.accessToken;
  if (token) {
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    return token;
  }
  throw new Error('No access token received');
}

/**
 * Cek apakah error termasuk error jaringan atau cooldown refresh.
 * Jika true: jangan redirect ke login (hindari lockout saat server down).
 */
export { isNetworkOrServerError, isRefreshCooldownError } from '../utils/networkErrorUtils';
